import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import {
  updateFieldReducer,
  setDurationReducer,
  setStartDateReducer,
  setEndDateReducer,
  setSelectedMonthReducer
} from './campaignDetailReducer';

export const campaignDetailSlice = createSlice({
  name: 'campaignDetail',
  initialState,
  reducers: {
    updateField: updateFieldReducer,
    setDuration: setDurationReducer,
    setStartDate: setStartDateReducer,
    setEndDate: setEndDateReducer,
    setSelectedMonth: setSelectedMonthReducer
  }
});

export const {
  updateField,
  setDuration,
  setStartDate,
  setEndDate,
  setSelectedMonth
} = campaignDetailSlice.actions;

export default campaignDetailSlice.reducer;
